import store from '@/store/index.js'
let dic = store.state.dic;
import { getOrgOptions } from "@/libs/searchSelect.js";
export default function Configs(that) {

    const searchItems = [
        {
            label: "学院",
            span: 6,
            type: 'select',
            model: "collegeId",
            options: [],
            clearable: true,
            change(data) {
                // console.log(data)
                let params = {
                    parentId: data,
                    type: 'department'
                }
                that.searchItems[1].options = [];
                that.searchItems[2].options = [];
                that.searchItems[3].options = [];
                that.pageParams.departmentId = "";
                that.pageParams.majorId = "";
                that.pageParams.classId = "";
                if (data) {
                    getOrgOptions(that, params, 1, null)
                }
            },
        },
        {
            label: "系别",
            span: 6,
            type: 'select',
            model: "departmentId",
            options: [],
            clearable: true,
            change(data) {
                let params = {
                    parentId: data,
                    type: 'major'
                }
                that.searchItems[2].options = [];
                that.searchItems[3].options = [];
                that.pageParams.majorId = "";
                that.pageParams.classId = "";
                if (data) {
                    getOrgOptions(that, params, 2, null)
                }
            },
        },
        {
            label: "专业",
            span: 6,
            type: 'select',
            model: "majorId",
            options: [],
            clearable: true,
            change(data) {
                console.log(data)
                let params = {
                    parentId: data,
                    type: 'class'
                }
                that.searchItems[3].options = [];
                that.pageParams.classId = '';
                if (data) {
                    getOrgOptions(that, params, 3, null)
                }
            },
        },
        {
            label: "班级",
            span: 6,
            type: 'select',
            model: "classId",
            options: [],
            clearable: true,
        },
        {
            label: "身份证号",
            span: 6,
            model: "idCard",
            clearable: true,
        },
        {
            label: "姓名",
            span: 6,
            placeholder: '请输入姓名',
            model: "studentName",
        },
        {
            label: "抑郁严重指数",
            span: 8,
            type: 'select',
            model: "depression",
            labelWidth: '120px',
            options: [
                { label: '无抑郁', value: '1' },
                { label: '轻微至轻度抑郁', value: '2' },
                { label: '中度至重度抑郁', value: '3' },
                { label: '重度抑郁', value: '4' },
            ],
            clearable: true,
        },
        // {
        //     label: "入学年份",
        //     span: 6,
        //     model: 'enrollmentYear',
        //     type: 'year',
        //     clearable: true,
        // },
    ]

    const tableColumns = [
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "身份证号",
            prop: "idCard",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true,

        },
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            show: true,
            minWidth: 180,
        },
        // {
        //     label: "系别",
        //     prop: "departmentName",
        //     align: "center",
        //     show: true,
        //     minWidth: 180,
        // },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            show: true,
            minWidth: 260,
        },
        // {
        //     label: "班级",
        //     prop: "className",
        //     align: "center",
        //     minWidth: 160,
        //     show: true
        // },
        {
            label: "分数",
            prop: "score",
            align: "center",
            minWidth: 80,
            show: true
        },
    ]

    return {
        searchItems,
        tableColumns,
    }
}
